import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

function TabPanel({ children, value, index, style, ...other }) {
  return (
    <Typography
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3} style={style}>
          {children}
        </Box>
      )}
    </Typography>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
  }
}))

function FullWidthTabs({ currentTabIndex, tabs, tabContents, tabChanged, variant, scrollButtons }) {
  const classes = useStyles()
  const theme = useTheme()

  const tabDisplay = tabs.map(tab => {
    return <Tab key={tab.key} label={tab.label} {...a11yProps(tab.label)} />
  })

  const tabData = tabContents.map((content, index) => {
    return (
      <TabPanel
        key={content.key}
        style={content.style}
        value={currentTabIndex}
        index={index}
        dir={theme.direction}>
        {content.display}
      </TabPanel>
    )
  })

  return (
    <div className={classes.root}>
      <Tabs
        value={currentTabIndex}
        onChange={tabChanged}
        indicatorColor='primary'
        textColor='primary'
        variant={variant || 'fullWidth'}
        scrollButtons={scrollButtons || 'auto'}
        aria-label={`${variant} tabs`}>
        {tabDisplay}
      </Tabs>
      {tabData}
    </div>
  )
}

FullWidthTabs.propTypes = {
  variant: PropTypes.oneOf(['standard', 'fullWidth', 'scrollable']),
  currentTabIndex: PropTypes.any.isRequired,
  tabs: PropTypes.array.isRequired,
  tabContents: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.node.isRequired
    })
  ).isRequired,
  tabChanged: PropTypes.func.isRequired,
  scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'on', 'off'])
}

export default FullWidthTabs
